import { Link } from 'react-router-dom';
import { categories } from '@/mocks/news';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-12 bg-primary-950 text-background-200">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-flashlight-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-extrabold text-background-50">
                911<span className="text-accent-400">爆料网</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              专注社会热点与爆料新闻，提供权威、及时、多角度的资讯内容，帮助你第一时间了解身边发生的事。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-background-200">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-background-200">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-background-200">
                <i className="ri-mail-line text-lg"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50">
              新闻栏目
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/category/${c.id}`}
                    className="transition-colors hover:text-accent-400"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50">
              关于本站
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/submit" className="transition-colors hover:text-accent-400">
                  我要爆料
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-accent-400">
                  搜索资讯
                </Link>
              </li>
              <li>
                <span className="text-background-300">版权与免责声明</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50">
              联系与投稿
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <a href="mailto:tip@911news.example" className="transition-colors hover:text-accent-400">
                  tip@911news.example
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400"></i>
                <span>400-000-9110</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400"></i>
                <span>网络举报受理中心</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800/70 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 911爆料网 · 本站为演示站点，内容均为示例数据</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>内容仅供参考</span>
            <span>理性看待突发信息</span>
            <span>不构成任何决策建议</span>
          </p>
        </div>
      </div>
    </footer>
  );
}